import { useUser } from '../context/CurrentUserContext'
import { formatDateTime } from '../utilities/formatDateTime'

const DateTimeDisplay = ({ date, showTime = false }) => {
  const { user } = useUser()
  const userTimezone = user.settings.timezone || 'UTC'
  const userDateFormat = user.settings.dateFormat || 'iso'

  return formatDateTime(date, userTimezone, userDateFormat, showTime)
}

export default DateTimeDisplay
